import { useQuery } from '@tanstack/react-query';
import { Account } from '@types';
import { instance } from '@utils/fetch';
import { config } from '../config';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { fetchAccountAsync } from '@store/actions/accounts.action';

type useAccountsQueryProps = {
    enabled: boolean;
};
export const useAccountsQuery = (options?: useAccountsQueryProps) => {
    const dispatch = useDispatch();

    const query = useQuery<Account, any>({
        queryKey: ['accounts'],
        queryFn: async () =>
            await instance.request({
                url: `${config.env('customerAccountsUrl')}`,
                method: 'get',
                headers: {
                    'x-api-key': `${config.env('xApiKey')}`
                }
            }),
        select: ({ data }: any) => data,
        useErrorBoundary: false,
        enabled: options.enabled
    });
    useEffect(() => {
        if (query.isSuccess) {
            dispatch(fetchAccountAsync.success(query.data));
        } else if (query.isError) {
            dispatch(fetchAccountAsync.failure(query.error));
        }
    }, [query.isSuccess, query.isError]);

    return query;
};
